import { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [garage, setGarage] = useState(null);
  const [status, setStatus] = useState("loading"); // loading | authed | anon

  useEffect(() => {
    const t = getToken();
    if (!t) {
      setStatus("anon");
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data.user);
        setGarage(r.data.garage);
        setStatus("authed");
      })
      .catch(() => {
        setToken(null);
        setStatus("anon");
      });
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    // 2FA gate: don't set token yet; return raw response so UI can prompt OTP
    if (r.data?.requires_2fa) {
      return r.data;
    }
    setToken(r.data.token);
    setUser(r.data.user);
    setGarage(r.data.garage);
    setStatus("authed");
    return r.data;
  };

  const requestOtp = async (email) => {
    const r = await api.post("/auth/otp/request", { email });
    return r.data;
  };

  const verifyOtp = async (email, otp) => {
    const r = await api.post("/auth/otp/verify", { email, otp });
    setToken(r.data.token);
    setUser(r.data.user);
    setGarage(r.data.garage);
    setStatus("authed");
    return r.data;
  };

  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    setToken(r.data.token);
    setUser(r.data.user);
    setGarage(r.data.garage);
    setStatus("authed");
    return r.data;
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    setGarage(null);
    setStatus("anon");
  };

  return (
    <AuthContext.Provider value={{ user, garage, status, login, register, logout, requestOtp, verifyOtp }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
